import React from 'react'
import { Table, Grid, Icon } from 'semantic-ui-react'
import Tooltip from './Tooltip'
import { activeAdminLink } from '../helpers/navigationHelpers'
import { NOTIFICATION_STATUS_CHANGE, NOTIFICATION_ORDER_CREATED } from '../constants/orders'
import { BRIGHT_ORANGE, OFF_WHITE } from '../constants/colors'

export default class NavBarNotifications extends React.Component {
  notificationText = (notification) => {
    const { id, notification_to_status, type } = notification

    if (type === NOTIFICATION_STATUS_CHANGE) {
      return <React.Fragment>
        {`Order `}
        <a href={activeAdminLink(`shop_orders/${id}`)} rel='noopener noreferrer' target='_blank'>
          {id}
        </a>
        {` is in `}
        <strong>{notification_to_status}</strong>
      </React.Fragment>
    }
    else if (type === NOTIFICATION_ORDER_CREATED) {
      return <React.Fragment>
        {`New Shop Order `}
        <a href={activeAdminLink(`shop_orders/${id}`)} rel='noopener noreferrer' target='_blank'>
          {id}
        </a>
      </React.Fragment>
    }

    return 'Notification received, type unknown'
  }

  render() {
    const contentStyle = {
      backgroundColor: 'red',
      color: 'white',
      borderRadius: '20px',
      padding: '7px',
      minWidth: '28px',
      minHeight: '25px',
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold',
      cursor: 'pointer'
    }
    const clearAllStyle = { color: BRIGHT_ORANGE, cursor: 'pointer', fontSize: '0.8rem' }
    const { notifications, clearNotification, clearAllNotifications } = this.props

    // We use a Grid instead of a Table.Header here because there was no way to make the width of
    // the header cells different than the table cells
    return (
      <Tooltip
        style={{padding: 0}}
        position={'bottom right'}
        trigger={<div style={contentStyle}>{notifications.length}</div>}
        content={
          <React.Fragment>
            <Grid style={{padding: '7px 14px 7px 10px'}}>
              <Grid.Column width={7}>
                <strong>Notifications</strong>
              </Grid.Column>
              <Grid.Column width={9} textAlign='right'>
                <div onClick={clearAllNotifications} style={clearAllStyle}>
                  <strong>Mark All as Read</strong>
                </div>
              </Grid.Column>
            </Grid>

            <Table style={{width: '400px', marginTop: 0, border: 0, borderRadius: 0}} basic>
              <Table.Body borderless='true' style={{maxHeight: '400px', overflowY: 'auto', display: 'block'}}>
                {notifications.map((notif, i) => {
                  return (
                    <Table.Row key={i} style={{ backgroundColor: OFF_WHITE, display: 'flex' }}>
                      <Table.Cell width={13}>
                        {this.notificationText(notif)}
                        <div><small>{notif.updated_at}</small></div>
                      </Table.Cell>
                      <Table.Cell width={3} textAlign='right'>
                        <Icon
                          style={{cursor: 'pointer'}}
                          onClick={() => clearNotification(notif)}
                          name='window close outline'
                        />
                      </Table.Cell>
                    </Table.Row>
                  )
                })}
              </Table.Body>
            </Table>
          </React.Fragment>
        }
      />
    )
  }
}
